<template>
  <div class="content">
    <div class="inner_content">
      <div class="header">
        会员数据导入步骤说明
      </div>
      <div class="box">
        <div>1、点击这里打开Excel表格，在Excel表格中录入数据。</div>
        <div>2、选择Excel数据文件：<el-button type="primary" size="small">选择文件</el-button></div>
        <div>3、点我<el-button type="primary" size="small">开始上传</el-button>，马上导入</div>
      </div>
      <div class="warnning">
        <div>注意事项:</div>
        <div>1、导入数据时，请仔细填写表格中的每一项数据，并严格按照指定的格式录入。</div>
        <div>2、一次性导入的数据量不易过大，对应大数据量建议分批次导入。</div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      
    };
  },
  mounted() {
  },
  
};
</script>
<style lang="scss" scoped>
.content {
  padding: 0 26px 11px 20px;
  height: calc(100vh - 102px);
  border: 1px solid #f1f1f1;
  overflow: auto;
  min-width: 900px;
  background:rgba(240,242,245,1);
  .inner_content{
    background: #fff;
    padding: 0 24px;
    height: 100%;
    .header{
      height: 50px;
      line-height: 50px;
      font-size: 16px;
      border-bottom: 1px solid #f1f1f1;
    }
    .box{
      padding-top: 14px;
      >div{
        font-size: 14px;
        line-height: 28px;
      }
    }
    .warnning{
      color: #f56c6c;
      margin-top: 50px;
      > div{
        line-height: 26px;
      }
    }
  }
}
// 通用样式
.flex{
  display: flex;
  align-items: center;
  padding: 10px 0px;
}
</style>
